import { render, staticRenderFns } from "./ClientsChart.vue?vue&type=template&id=67288f8c&"
import script from "./ClientsChart.vue?vue&type=script&lang=js&"
export * from "./ClientsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67288f8c')) {
      api.createRecord('67288f8c', component.options)
    } else {
      api.reload('67288f8c', component.options)
    }
    module.hot.accept("./ClientsChart.vue?vue&type=template&id=67288f8c&", function () {
      api.rerender('67288f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/ClientsChart.vue"
export default component.exports